import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.ui`;

export const SAVE_DASHBOARD_PROMPT_VISIBILITY = `${SCOPE}/SAVE_DASHBOARD_PROMPT_VISIBILITY`;

export const TOGGLE_UPDATE_POPUP_VISIBLE = `${SCOPE}/TOGGLE_UPDATE_POPUP_VISIBLE`;
export const TOGGLE_REMOVE_POPUP_VISIBLE = `${SCOPE}/TOGGLE_REMOVE_POPUP_VISIBLE`;
export const SET_ACTIVE_DASHBOARD_ID = `${SCOPE}/SET_ACTIVE_DASHBOARD_ID`;
